/* Pack Blendazo — lógica de la page */
(function () {
  'use strict';

  // ── Ocultar header/announcement bar nativos del theme ──
  // Fallback: oculta todo lo que esté antes de .blendazo-page dentro del body
  function hideNativeChrome() {
    var page = document.querySelector('.blendazo-page');
    if (!page) return;

    // Buscar el contenedor tope dentro de body que contenga a .blendazo-page
    var node = page;
    while (node.parentElement && node.parentElement !== document.body) {
      node = node.parentElement;
    }
    // node es el hijo directo de body que contiene a la blendazo-page

    // Ocultar todos los hermanos previos y siguientes (header, announcement bar, footer)
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === node) return;
      var tag = child.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return;
      // Preservar widgets tipo WhatsApp (zIndex alto, position fixed)
      var cs = window.getComputedStyle(child);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) > 100) return;
      child.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideNativeChrome);
  } else {
    hideNativeChrome();
  }

  // ── Hero carousel (cross-fade) ──
  (function () {
    var slides = document.querySelectorAll('.blendazo-page .hero-slide');
    if (slides.length < 2) return;

    var INTERVAL = 4000; // 4 segundos por foto
    var i = 0;

    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, INTERVAL);
  })();

  // ── FAQ accordion ──
  document.querySelectorAll('.blendazo-page .faq-item').forEach(function (item) {
    var row = item.querySelector('.faq-q-row');
    if (!row) return;
    row.addEventListener('click', function () {
      item.classList.toggle('open');
    });
  });

  // ── Qty + precios + cross-sell ──
  var qty = 1;
  // Precio de venta por pack: viene directo de Shopify (product.price).
  var PRICE = (typeof window.BLENDAZO_PRICE === 'number' && window.BLENDAZO_PRICE > 0)
    ? window.BLENDAZO_PRICE : 45000;
  // Precio tachado (compare_at_price). 0 si no hay descuento configurado.
  var COMPARE = (typeof window.BLENDAZO_COMPARE === 'number' && window.BLENDAZO_COMPARE > PRICE)
    ? window.BLENDAZO_COMPARE : 0;
  var MIN = 1;
  var MAX = 10;

  // Cross-sell addons — escalan con qty del pack
  var addons = { pan: false, cheddar: false };
  var ADDON_UNIT = { pan: 15000, cheddar: 16500 };
  var ADDON_PER_PACK_QTY = { pan: 12, cheddar: 24 }; // unidades por pack (mínimos)

  function fmt(n) {
    return '$' + Math.round(n).toLocaleString('es-AR');
  }

  function addonTotal() {
    var total = 0;
    if (addons.pan)     total += ADDON_UNIT.pan * qty;
    if (addons.cheddar) total += ADDON_UNIT.cheddar * qty;
    return total;
  }

  function updatePrices() {
    var packTotal = PRICE * qty;                         // lo que paga (precio Shopify)
    var compareTotal = (COMPARE > 0 ? COMPARE : PRICE) * qty; // precio "lista" (tachado)
    var saving = (COMPARE > 0 ? (COMPARE - PRICE) : 0) * qty; // descuento
    var extras = addonTotal();
    var total = packTotal + extras;

    var qtyEl = document.getElementById('qty-display');
    var savEl = document.getElementById('saving-display');
    var totEl = document.getElementById('total-display');
    var btnEl = document.getElementById('btn-total');
    var dispEl = document.getElementById('displayed-price');
    var packLbl = document.getElementById('br-pack-label');
    var packValEl = document.getElementById('br-pack-val');
    var discRow = document.getElementById('br-disc-row');

    if (qtyEl)  qtyEl.textContent  = qty;
    if (savEl)  savEl.textContent  = '−' + fmt(saving);
    if (totEl)  totEl.textContent  = fmt(total);
    if (btnEl)  btnEl.textContent  = fmt(total);
    if (dispEl) dispEl.textContent = fmt(packTotal);
    if (packLbl) packLbl.textContent = 'Pack Blendazo x' + qty + ' (Octa · Palermo · Pampeano)';
    if (packValEl) packValEl.textContent = fmt(compareTotal);
    if (discRow) discRow.style.display = (saving > 0) ? '' : 'none';

    // Pan
    var panQty = ADDON_PER_PACK_QTY.pan * qty;
    var panQtyEl = document.getElementById('cs-pan-qty');
    var panPriceEl = document.getElementById('cs-pan-price');
    if (panQtyEl)   panQtyEl.textContent   = 'x' + panQty;
    if (panPriceEl) panPriceEl.textContent = '+' + fmt(ADDON_UNIT.pan * qty);

    // Cheddar
    var chQty = ADDON_PER_PACK_QTY.cheddar * qty;
    var chQtyEl = document.getElementById('cs-cheddar-qty');
    var chPriceEl = document.getElementById('cs-cheddar-price');
    if (chQtyEl)   chQtyEl.textContent   = 'x' + chQty;
    if (chPriceEl) chPriceEl.textContent = '+' + fmt(ADDON_UNIT.cheddar * qty);

    // Filas del breakdown (pan / cheddar)
    var panRow = document.getElementById('br-pan-row');
    var chRow = document.getElementById('br-cheddar-row');

    if (panRow) {
      if (addons.pan) {
        panRow.classList.remove('crosssell-hidden');
        document.getElementById('br-pan-label').textContent = 'Pan de hamburguesa Kalis x' + panQty;
        document.getElementById('br-pan-val').textContent = '+' + fmt(ADDON_UNIT.pan * qty);
      } else {
        panRow.classList.add('crosssell-hidden');
      }
    }
    if (chRow) {
      if (addons.cheddar) {
        chRow.classList.remove('crosssell-hidden');
        document.getElementById('br-cheddar-label').textContent = 'Fetas de Queso Cheddar x' + chQty;
        document.getElementById('br-cheddar-val').textContent = '+' + fmt(ADDON_UNIT.cheddar * qty);
      } else {
        chRow.classList.add('crosssell-hidden');
      }
    }
  }

  window.changeQty = function (delta) {
    qty = Math.max(MIN, Math.min(MAX, qty + delta));
    updatePrices();
  };

  // Helper: título inicial según disponibilidad
  function tituloInicial() {
    if (window.PAN_AVAILABLE) return '¿Te lo vas a llevar sin pan?';
    if (window.CHEDDAR_AVAILABLE) return '¿Le sumás el cheddar?';
    return '';
  }

  // Cross-sell: revelado progresivo (pan → cheddar) con awareness de stock
  window.toggleAddon = function (id) {
    addons[id] = !addons[id];

    var item = document.getElementById('cs-' + id);
    var check = document.getElementById('cs-' + id + '-check');
    if (item) item.classList.toggle('selected', addons[id]);
    if (check) check.textContent = addons[id] ? '✓' : '';

    var titulo = document.getElementById('cs-titulo');

    if (id === 'pan') {
      var cheddarEl = document.getElementById('cs-cheddar');
      if (addons.pan) {
        // Pan seleccionado → revelar cheddar SI hay stock
        if (cheddarEl && window.CHEDDAR_AVAILABLE) {
          cheddarEl.classList.remove('crosssell-hidden');
          cheddarEl.classList.add('crosssell-visible');
          if (titulo) titulo.textContent = '¿Y el cheddar?';
        } else {
          // No hay cheddar → cerrar el flow
          if (titulo) titulo.textContent = '¡Sumado!';
        }
      } else {
        // Pan deseleccionado → ocultar cheddar y resetearlo
        if (cheddarEl) {
          cheddarEl.classList.add('crosssell-hidden');
          cheddarEl.classList.remove('crosssell-visible');
        }
        addons.cheddar = false;
        var chItem = document.getElementById('cs-cheddar');
        var chCheck = document.getElementById('cs-cheddar-check');
        if (chItem) chItem.classList.remove('selected');
        if (chCheck) chCheck.textContent = '';
        if (titulo) titulo.textContent = tituloInicial();
      }
    }

    if (id === 'cheddar') {
      if (addons.cheddar) {
        if (titulo) titulo.textContent = '¡Todo listo!';
      } else {
        // Si pan también está seleccionado, vuelve al prompt de cheddar
        // Si no, vuelve al título inicial
        if (titulo) titulo.textContent = addons.pan ? '¿Y el cheddar?' : tituloInicial();
      }
    }

    updatePrices();
  };

  // ── Scroll al funnel ──
  window.scrollToBuy = function () {
    var el = document.getElementById('funnel');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  // ── Shopify Cart API: agregar pack + addons + redirect a /checkout ──
  window.handleBuyPack = async function () {
    var variantId = window.BLENDAZO_VARIANT_ID;
    if (!variantId) {
      console.error('Blendazo: variant ID no definido');
      return;
    }

    var items = [{ id: variantId, quantity: qty }];

    // Sumar addons como line items separados (si tienen variant ID + stock disponible)
    if (addons.pan && window.PAN_VARIANT_ID && window.PAN_AVAILABLE) {
      items.push({ id: window.PAN_VARIANT_ID, quantity: qty });
    }
    if (addons.cheddar && window.CHEDDAR_VARIANT_ID && window.CHEDDAR_AVAILABLE) {
      items.push({ id: window.CHEDDAR_VARIANT_ID, quantity: qty });
    }

    // Si el cliente seleccionó addons pero no hay variant ID, los registramos como properties
    var properties = {};
    if (addons.pan && !window.PAN_VARIANT_ID) {
      properties['Pan Kalis'] = 'x' + (ADDON_PER_PACK_QTY.pan * qty);
    }
    if (addons.cheddar && !window.CHEDDAR_VARIANT_ID) {
      properties['Cheddar Milkaut'] = 'x' + (ADDON_PER_PACK_QTY.cheddar * qty) + ' fetas';
    }
    if (Object.keys(properties).length > 0) {
      items[0].properties = properties;
    }

    var btns = document.querySelectorAll('.funnel-btn');
    btns.forEach(function (b) { b.disabled = true; });

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      if (response.ok) {
        window.location.href = '/checkout';
      } else {
        var err = await response.text();
        console.error('Error al agregar al carrito:', err);
        btns.forEach(function (b) { b.disabled = false; });
      }
    } catch (err) {
      console.error(err);
      btns.forEach(function (b) { b.disabled = false; });
    }
  };

  // init
  updatePrices();
})();
